// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"sidebar_activeTab__bZG0z","arrow":"sidebar_arrow__1mx7Y"};